// actions
import * as actions from './actions';

const initialState = {
  success: null,
  error: null,
  loadingSync: false,
  loadingMail: false,
};

export default function brevoUtilityReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SYNC_BREVO.REQUEST:
      return { ...state, isLoading: true, error: null };

    case actions.SYNC_BREVO.SUCCESS:
      return { ...state, isLoading: false, success: action.payload };

    case actions.SYNC_BREVO.FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case actions.SEND_MAILING_CAMPAIGN.REQUEST:
      return { ...state, isLoading: true, error: null };

    case actions.SEND_MAILING_CAMPAIGN.SUCCESS:
      return { ...state, isLoading: false, success: action.payload };

    case actions.SEND_MAILING_CAMPAIGN.FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
};